import {Optional, SkipSelf} from '@angular/core';

export class DisabledDirective {
    constructor(
        @SkipSelf() @Optional() private optParent: DisabledDirective
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/util/disableDirective.ts